<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconName"/>
  </svg>
</template>

<script lang="ts" setup>
import {computed} from "vue";

const props = defineProps({
  iconClass: String,
  className: String,
});

/** 图标名称 */
const iconName = computed(() => `#icon-${props.iconClass}`);
const svgClass = computed(() => `svg-icon ${props.className ? props.className : props.iconClass}`);
// const styleExternalIcon = computed(() => {
//   return {
//     mask: `url(${props.iconClass}) no-repeat 50% 50%`,
//     "-webkit-mask": `url(${props.iconClass}) no-repeat 50% 50%`,
//   };
// });
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  /* vertical-align: -0.15em; */
  fill: currentColor;
  overflow: hidden;
}

.svg-external-icon {
  background-color: currentColor;
  mask-size: cover !important;
  display: inline-block;
}
</style>
